import { render, staticRenderFns } from "./Insemination.report.vue?vue&type=template&id=122e73b6&scoped=true&"
import script from "./Insemination.report.vue?vue&type=script&lang=js&"
export * from "./Insemination.report.vue?vue&type=script&lang=js&"
import style0 from "./Insemination.report.vue?vue&type=style&index=0&id=122e73b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e73b6",
  null
  
)

export default component.exports